/* eslint-disable react/prop-types */
import { useState, useEffect } from 'react'
import styles from './styles.module.css'
import {
  CircleX,
  Cross,
  Interrogation,
  // ArrowDown,
} from '../../../../assets/svgs/icons'
import Masonry from 'react-responsive-masonry'

import {
  // BusinessService,
  // MyUploadsService,
  ProductService,
} from '../../../../services'
import { Loading } from '../../../../components/Loading'

import {
  notifyErrorCustom,
  // notifySuccessCustom,
} from '../../../../utils/notify'

import { useClient } from '../../../../hooks/useClient'
// import { getBusinessByClientId } from '../../../../services/business'
// import { Select } from 'antd'
// import { SelectSquare } from '../../../../components/Select/SelectSquare/SelectSquare'
import { useTranslation } from 'react-i18next'

const ModalProducts = ({ closeModal, setImageProductsArray }) => {
  const { t } = useTranslation()
  const { clientData } = useClient()

  const [selectedImages, setSelectedImages] = useState([])
  const [selectedArrayImage, setSelectedArrayImage] = useState([])

  const [images, setImages] = useState([])
  const [products, setProducts] = useState([])

  const [loading, setLoading] = useState(false)

  useEffect(() => {
    loadData()
  }, [])

  const loadData = async () => {
    setLoading(true)

    if (clientData?.uuid) {
      const response = await ProductService.getProductByBusinessClientId(
        clientData?.uuid
      )

      if (response.responseStatus === 200) {
        const arrayProducts = response.data

        setProducts(arrayProducts)
      } else {
        notifyErrorCustom(
          t(
            'new_publication_page_campaign_step_second_pass_modal_products_error_message'
          )
        )
      }
    } else {
      const response = await ProductService.getProductByNotBusinessClient()
      if (response.responseStatus === 200) {
        const arrayProducts = response.data

        setProducts(arrayProducts)
      } else {
        notifyErrorCustom(
          t(
            'new_publication_page_campaign_step_second_pass_modal_products_error_message'
          )
        )
      }
    }
    setLoading(false)
  }

  const handleChange = async (value) => {
    setLoading(true)
    const response = await ProductService.getProductImage64ByProductId(value)

    setImages(response.data)
    setLoading(false)
  }

  const handleImageClick = (imageUrl) => {
    const imageArray = images.find(
      (image) => image.fileBase64 === imageUrl.fileBase64
    )

    if (imageArray) {
      const arrayExists = selectedArrayImage.some(
        (arr) => JSON.stringify(arr) === JSON.stringify(imageArray)
      )

      if (arrayExists) {
        setSelectedArrayImage(
          selectedArrayImage.filter(
            (arr) => JSON.stringify(arr) !== JSON.stringify(imageArray)
          )
        )
      } else {
        setSelectedArrayImage([...selectedArrayImage, imageArray])
      }
    }

    if (selectedImages.includes(imageUrl.fileBase64)) {
      setSelectedImages(
        selectedImages.filter((image) => image !== imageUrl.fileBase64)
      )
    } else {
      setSelectedImages([...selectedImages, imageUrl.fileBase64])
    }
  }

  const handleRemoveImage = (imageArray) => {
    setSelectedArrayImage(
      selectedArrayImage.filter(
        (arr) => JSON.stringify(arr) !== JSON.stringify(imageArray)
      )
    )

    if (selectedImages.includes(imageArray.fileBase64)) {
      setSelectedImages(
        selectedImages.filter((image) => image !== imageArray.fileBase64)
      )
    } else {
      setSelectedImages([...selectedImages, imageArray.fileBase64])
    }
  }

  const addImages = async () => {
    let newSelectedArrayImage = selectedArrayImage.map((image) => {
      return {
        id: image.productId,
        image: image.fileUrl,
        isOriginal: true,
        fileDataBase64: `data:image/png;base64,${image.fileBase64}`,
        type: image.fileContentType,
        //name: image.fileName,
        imageName: image.fileName,
        productId: image.productId,
        productName: image.productName,
        productDescription: image.description,
        productValue: image.value,
        productPromotionValue: image.promotionalValue,
        isBackgroundRemoved: false,
      }
    })

    setImageProductsArray(newSelectedArrayImage)

    closeModal('produtos')
  }

  return (
    <div className={styles.modal}>
      <Loading enable={loading} />
      <div className={styles.header_close}>
        <div
          className={styles.close_modal}
          onClick={() => closeModal('produtos')}
        >
          <Cross width={'20px'} height={'20px'} />
        </div>
      </div>
      <div className={styles.modal_title}>
        <h2>
          {t(
            'new_publication_page_campaign_step_second_pass_modal_products_title'
          )}{' '}
          <Interrogation color={'#FF8B00'} />
        </h2>
      </div>
      <div className={styles.modal_sub_title}>
        <p className={styles.modal_sub_title_text}>
          {t(
            'new_publication_page_campaign_step_second_pass_modal_products_subtitle'
          )}
        </p>
      </div>
      <select
        className={styles.modal_select}
        onChange={(e) => handleChange(e.target.value)}
      >
        <option className={styles.modal_option} value={null}>
          {t(
            'new_publication_page_campaign_step_second_pass_modal_products_select_product'
          )}
        </option>
        {products.map((product) => (
          <option
            key={product.uuid}
            className={styles.modal_option}
            value={product.uuid}
          >
            {product.name}
          </option>
        ))}
      </select>

      <div className={styles.container_galeyimages}>
        <Masonry columnsCount={3} gutter="10px">
          {images.map((imageUrl, i) => (
            <img
              key={i}
              src={imageUrl.fileUrl}
              onClick={() => handleImageClick(imageUrl)}
              className={
                selectedImages.includes(imageUrl.fileBase64)
                  ? styles.selectedImage
                  : styles.image
              }
              //onContextMenu={(e) => e.preventDefault()}
            />
          ))}
        </Masonry>
      </div>

      {selectedArrayImage.length !== 0 && (
        <div className={styles.contaier_caroucel_list_selected_image}>
          <p>
            {t(
              'new_publication_page_campaign_step_second_pass_modal_products_selected_products'
            )}
          </p>
          <div className={styles.caroucel_list_selected_image}>
            {selectedArrayImage.map((imageArray) => (
              <div
                className={styles.card_lis_selected_image}
                key={imageArray.id}
              >
                <div className={styles.container_card_lis_selected_image}>
                  <div
                    className={styles.delete_card_lis_selected_image}
                    onClick={() => handleRemoveImage(imageArray)}
                  >
                    <div style={{ cursor: 'pointer' }}>
                      <CircleX
                        color={'#FF2F00'}
                        width={'15px'}
                        height={'15px'}
                      />
                    </div>
                  </div>
                  <img
                    className={styles.item_selected_image}
                    src={imageArray.fileUrl}
                    //onContextMenu={(e) => e.preventDefault()}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      )}
      {selectedArrayImage.length !== 0 && (
        <button
          className={styles.button_add_image}
          onClick={() => {
            addImages()
          }}
        >
          {t(
            'new_publication_page_campaign_step_second_pass_modal_products_add_products_button'
          )}
        </button>
      )}
    </div>
  )
}

export default ModalProducts
